import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=034682fb&scoped=true&lang=pug"
import script from "./SettingsModal.vue?vue&type=script&lang=js"
export * from "./SettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034682fb",
  null
  
)

export default component.exports